import { MutationHandlingServiceV2 } from '@akebono/core';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { of, Subject } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';
import { NegotiationsService } from 'src/app/services/negotiations.service';

import {
  LotNegotiationsOpenGQL,
  LotSource,
  LotTypeEnum,
  UserLotQuery,
} from '../../../../graphql/service/graphql-auto-main-service';

@Component({
  selector: 'app-lot-negotiations-price-form-modal',
  templateUrl: './lot-negotiations-price-form-modal.component.html',
  styleUrls: ['./lot-negotiations-price-form-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotNegotiationsPriceFormModalComponent implements OnInit, OnDestroy {
  @Input() savedLot: UserLotQuery['lot'];
  @Input() lotId: string;
  @Input() lotType: LotTypeEnum;
  @Input() lotSource: LotSource;
  @Output() actionCompleted = new EventEmitter<void>();

  price: number;
  loading$ = of(false);

  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly modal: NzModalRef,
    private readonly mhs: MutationHandlingServiceV2,
    private readonly lotNegotiationsOpenGQL: LotNegotiationsOpenGQL,
    private readonly negotiationsService: NegotiationsService,
  ) {}

  ngOnInit(): void {
    this.price = Number(this.savedLot.negotiationsPrice) || null;
  }

  get canSave(): boolean {
    return (
      Number.isInteger(this.price) &&
      this.price > 0 &&
      !!(this.savedLot.canOpenNegotiations || this.savedLot.canEditNegotiationsPrice)
    );
  }

  saveNegotiationsPrice(): void {
    if (!this.canSave) {
      return;
    }

    const mutationRef = this.mhs.mutate(this.lotNegotiationsOpenGQL, {
      input: {
        lotId: this.lotId,
        lotType: this.lotType,
        lotSource: this.lotSource,
        negotiationsPrice: this.price,
      },
    });
    this.loading$ = mutationRef.loading;
    mutationRef.data.pipe(first(), takeUntil(this.destroy$)).subscribe(() => {
      this.negotiationsService.refresh();
      this.actionCompleted.emit();
      this.close();
    });
  }

  close(): void {
    this.modal.destroy();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
